// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sprite-ballon-animation {
  height: 424px;
  margin-top: 10px;
  margin-left: 0;
  position: relative;
  animation: ballon-transition 0.5s ease forwards;
  animation-duration: 2s;
  animation-iteration-count: 1;
}
@keyframes ballon-transition {
  from {
    top: 60%;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PopBallon/PopAnimation/popAnimation.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EAEA,+CAAA;EACA,sBAAA;EACA,4BAAA;AAAJ;AAGA;EACI;IACI,QAAA;IACA,UAAA;EADN;EAIE;IACI,MAAA;IACA,UAAA;EAFN;AACF","sourcesContent":[".sprite-ballon-animation{ \n    height: 424px; \n    margin-top: 10px;\n    margin-left: 0;\n    position: relative;\n\n    animation: ballon-transition 0.5s ease forwards;\n    animation-duration: 2s;\n    animation-iteration-count: 1;;\n}\n\n@keyframes ballon-transition{\n    from {\n        top: 60%;\n        opacity: 0;\n    }\n\n    to {\n        top: 0;\n        opacity: 1;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
